import type { OffersTypes } from '../types';
import type { Promotion } from '../types/analytics';

export const convertToPromotionsType = (offers: OffersTypes) => {
  let promotionOffer = {} as Promotion;
  if (offers) {
    const { offerType, offerDetails } = offers;
    const { aprRate, creditBonus, customerDownPayment, monthlyPayment, term } = offerDetails;

    let aprFinance = '';
    let termLengthFinance = '';
    let downPaymentLease = '';
    let paymentLease = '';
    let termLengthLease = '';
    let bonusCredit = '';

    if (offerType === 'credit') {
      bonusCredit = `${creditBonus}`;
    }

    if (offerType === 'finance') {
      aprFinance = `${aprRate}`;
      termLengthFinance = `${term}`;
    }

    if (offerType === 'lease') {
      paymentLease = `${monthlyPayment}`;
      termLengthLease = `${term}`;
      downPaymentLease = `${customerDownPayment}`;
    }

    promotionOffer = {
      type: offerType,
      offerdate: '',
      credit: bonusCredit,
      leaseDownpayment: downPaymentLease,
      leasePayment: paymentLease,
      leaseTermlength: termLengthLease,
      financeApr: aprFinance,
      financeTermlength: termLengthFinance,
    };
  }

  return promotionOffer;
};
